__turbopack_context__.v({
  "card": "Azj5Qq_card",
  "cardHeader": "Azj5Qq_cardHeader",
  "eaBadge": "Azj5Qq_eaBadge",
  "eaLabel": "Azj5Qq_eaLabel",
  "eaTime": "Azj5Qq_eaTime",
  "image": "Azj5Qq_image",
});
